export default "__VITE_ASSET__b874a301__"